module.exports = __webpack_public_path__ + "img/ios-home-01.5c72e374.jpg";